export { default } from './ButtonSquare';



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/BasicButton/index.js